import angular from "angular";
import { MaskedStaticTextFaComponent } from "./masked-static-text-fa.component";
import { MaskFilter } from "./mask-filter.filter";

export const MaskedStaticTextModule = angular
    .module("apex.mainApp.shared.masking", [])
    .component("apexMaskedStaticText", MaskedStaticTextFaComponent)
    .filter("apexMask", MaskFilter)
    .name;
